import { connect } from 'react-redux'
import DashboardSkeleton from 'pages/dashboard/DashboardSkeleton'

const mapStateToProps = state => ({
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight
})

export default connect(mapStateToProps, null)(DashboardSkeleton)
